import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import TableSchedule from "./components/TableSchedule";
import HeaderSchedule from "./components/HeaderSchedule";

const Schedule = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleUserCreated = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <HeaderSchedule onScheduleCreated={handleUserCreated}>
        <MDBox mt={2} mb={0}>
          {/* <TableSchedule refreshFlag={refreshFlag} /> */}
        </MDBox>
      </HeaderSchedule>
    </DashboardLayout>
  );
};

export default Schedule;
